import { PropertyTypeTemplatesService } from './property-type-templates.service'
import {
  FetchPropertyTypeTemplatesRequest,
  FetchPropertyTypeTemplatesSuccess,
  FetchPropertyTypeTemplatesFailure,
  FetchPropertyTypeTemplateRequest,
  FetchPropertyTypeTemplateSuccess,
  FetchPropertyTypeTemplateFailure,
  DeletePropertyTypeTemplateRequest,
  DeletePropertyTypeTemplateSuccess,
  DeletePropertyTypeTemplateFailure,
  CreatePropertyTypeTemplateRequest,
  CreatePropertyTypeTemplateSuccess,
  CreatePropertyTypeTemplateFailure,
  UpdatePropertyTypeTemplateRequest,
  UpdatePropertyTypeTemplateSuccess,
  UpdatePropertyTypeTemplateFailure,
} from './property-type-templates.actions'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as propertyTypeTemplateTypes from './property-type-templates.types'
import { map, switchMap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class PropertyTypeTemplatesEffects {
  constructor(
    private actions: Actions,
    private propertyTypeTemplatesService: PropertyTypeTemplatesService,
    private router: Router,
  ) {}

  FetchTemplates$ = createEffect(() =>
    this.actions.pipe(
      ofType(propertyTypeTemplateTypes.FETCH_PROPERTY_TYPE_TEMPLATES_REQUEST),
      switchMap((action: FetchPropertyTypeTemplatesRequest) => {
        return this.propertyTypeTemplatesService
          .fetchPropertyTypeTemplates(action.payload)
          .pipe(
            map((result) => {
              return new FetchPropertyTypeTemplatesSuccess(
                result.data.results,
                result.data.filteredCount,
                result.data.totalCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchPropertyTypeTemplatesFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchTemplate$ = createEffect(() =>
    this.actions.pipe(
      ofType(propertyTypeTemplateTypes.FETCH_PROPERTY_TYPE_TEMPLATE_REQUEST),
      switchMap((action: FetchPropertyTypeTemplateRequest) => {
        return this.propertyTypeTemplatesService
          .fetchPropertyTypeTemplate(action.id)
          .pipe(
            map((result) => {
              return new FetchPropertyTypeTemplateSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(new FetchPropertyTypeTemplateFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  DeleteTemplate$ = createEffect(() =>
    this.actions.pipe(
      ofType(propertyTypeTemplateTypes.DELETE_PROPERTY_TYPE_TEMPLATE_REQUEST),
      switchMap((action: DeletePropertyTypeTemplateRequest) => {
        return this.propertyTypeTemplatesService
          .deletePropertyTypeTemplate(action.id)
          .pipe(
            switchMap((result) => {
              return [new DeletePropertyTypeTemplateSuccess()]
            }),
            catchError((err, caught) => {
              return of(new DeletePropertyTypeTemplateFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  CreateTemplate$ = createEffect(() =>
    this.actions.pipe(
      ofType(propertyTypeTemplateTypes.CREATE_PROPERTY_TYPE_TEMPLATE_REQUEST),
      switchMap((action: CreatePropertyTypeTemplateRequest) => {
        return this.propertyTypeTemplatesService
          .createPropertyTypeTemplate(action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/property-type-templates'])
              return [new CreatePropertyTypeTemplateSuccess()]
            }),
            catchError((err, caught) => {
              return of(new CreatePropertyTypeTemplateFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  UpdateTemplate$ = createEffect(() =>
    this.actions.pipe(
      ofType(propertyTypeTemplateTypes.UPDATE_PROPERTY_TYPE_TEMPLATE_REQUEST),
      switchMap((action: UpdatePropertyTypeTemplateRequest) => {
        return this.propertyTypeTemplatesService
          .updatePropertyTypeTemplate(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/property-type-templates'])
              return [new UpdatePropertyTypeTemplateSuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdatePropertyTypeTemplateFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
